/*
 * @Author: changcheng
 * @LastEditTime: 2022-12-30 15:08:28
 */
import React from "react";
import Country from "./country/index";
import Provice from "./province/index";
import City from "./city/index";
import SupportHospital from "./supportHospital/index";
import CountyHospital from "./countyHospital/index";
import { useSelector } from "react-redux";
import { RootState } from "@root/store";
import "./_style1.scss";
function Index() {
  const { baseUserCategory } = useSelector(
    (state: RootState) => state.userInfo
  );
  return (
    <div>
      <div>{baseUserCategory === "10" && <Country />}</div>
      <div> {baseUserCategory === "11" && <Provice />}</div>
      <div> {baseUserCategory === "15" && <City />}</div>
      <div> {baseUserCategory === "13" && <SupportHospital />}</div>
      <div> {baseUserCategory === "12" && <CountyHospital />}</div>
    </div>
  );
}

export default Index;
